import React, { useCallback, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import '../hotels/selecthotel/selecthotel.css'
import './hoteldetail.css'
import { Box, Button, ButtonGroup, Modal, Link, Tab, Tabs, InputLabel, Select ,FormControl, SvgIcon} from '@mui/material'
import star from '../../assets/images/star.svg'
import starinactive from '../../assets/images/starinactive.svg'
import PropTypes from 'prop-types'
import PersonIcon from '@mui/icons-material/Person'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import '../hotels/search/hotel.css'
import withStyles from '@mui/styles/withStyles';
import Dialog from '@mui/material/Dialog'
import MuiDialogTitle from '@mui/material/DialogTitle'
import MuiDialogContent from '@mui/material/DialogContent'
import MuiDialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useHistory } from 'react-router-dom'
import HotelBanner from './HotelBanner'
import parse from 'html-react-parser'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HotelIcon from '@mui/icons-material/Hotel';
import Header from '../header/Header'
import CheckIcon from '@mui/icons-material/Check';
import RowingIcon from '@mui/icons-material/Rowing';
import DateFnsUtils from '@date-io/date-fns'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
})

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props
  return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
          <Typography variant="h6">{children}</Typography>
          {onClose
            ? (
              <IconButton
                  aria-label="close"
                  className={classes.closeButton}
                  onClick={onClose}
                  size="large">
                  <CloseIcon />
              </IconButton>
              )
            : null}
      </MuiDialogTitle>
  );
})

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions)

function TabPanel (props) {
  const { children, value, index } = props

  return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
        >
            {value === index && (
                <Box className="tabboxhotel">
                    <Box>{children}</Box>
                </Box>
            )}
        </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

function hotelTabPanel (index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  }
}

const HotelDetails = (props) => {
  const history = useHistory()
  const [value, setValue] = useState(1)
  const [open, setOpen] = useState(false)
  const [advanceShow, setAdvanceShow] = useState(false)
  const [hotelDetails, setHotelDetails] = useState(null)
  const [roomDetails, setRoomDetails] = useState(null)
  const [modal, setModal] = React.useState(false);
  const handleModalOpen = () => setModal(true);
  const handleModalClose = () => setModal(false);
  const [roomShow, setRoomShow] = React.useState(false)

  const [selectText, setselectText] = useState(false)
const [menuIndex, setMenuIndex] = useState(false)


  const [travellerCount, setTravellerCount] = useState([{
    adult: [2],
    child: [0],
    childAge: []
  }])
  const [hotelInfo, setHotelInfo] = useState({
    city: '',
    fromCity: null,
    cityError: '',
    hotel_destination: '',
    hotel_checkin: '',
    inError: '',
    inDate: null,
    hotel_checkout: '',
    outError: '',
    outDate: null,
    rating: [],
    nationality: '',
    nationalityValue: null,
    country_of_residence: '',
    conutryValue: '',
    rooms: 1,
    nights: '',
    nerror: '',
    nextDay: null,
    selectedRating: []
  })

  const selectRoomCategory = (index) => {
    setMenuIndex(index)
    if(index === menuIndex){
        setselectText(true)
    }
    else{
        setselectText(false)
    }
  }
  
  const roomToggle = () => {
    setRoomShow(!roomShow)
  }
  const handleAddRoom = () => {

    if (travellerCount.length + 1 <= 4) {
      setHotelInfo({
        ...hotelInfo,
        rooms: travellerCount.length + 1
      })

      setTravellerCount([
        ...travellerCount,
        {
          adult: [1],
          child: [0],
          childAge: []
        }
      ])
    }
  }

  const handleRemoveRoom = () => {
    const list = [...travellerCount]
    list.splice(list.length - 1, 1)
    setTravellerCount(list)

    setHotelInfo({
      ...hotelInfo,
      rooms: list.length
    })
  }

  const handleCountPlus = useCallback(
    (id, type) => {
      const list = [...travellerCount]

      if (type === 'adults') {
        if (list[id].adult[0] < 4) {
          list[id].adult[0] = list[id].adult[0] + 1
          setTravellerCount(list)
        }
      } else {
        if (list[id].child[0] < 2) {
          list[id].childAge.push('1')
          list[id].child[0] = list[id].child[0] + 1
          setTravellerCount(list)
        }
      }
    }, [travellerCount]
  )

  const handleCountMinus = (id, type) => {
    const list = [...travellerCount]
    if (type === 'adults') {
      if (list[id].adult[0] > 1) {
        list[id].adult[0] = list[id].adult[0] - 1
        setTravellerCount(list)
      }
    } else {
      if (list[id].child[0] > 0) {
        list[id].childAge.pop()
        list[id].child[0] = list[id].child[0] - 1
        setTravellerCount(list)
      }
    }
  }

  const handleTabinChange = (event, newValue) => {
    setValue(newValue)
  }
  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const advanceToggle = () => {
    setAdvanceShow(!advanceShow)
  }

  function paxCount (item) {
    return Number(item.adult) + Number(item.child)
  }
  
  function sum (prev, next) {
    return prev + next
  }

  const handleBookingDetails = (tk, tkey) => {
    const obj = {
      booking_source: (hotelDetails && hotelDetails.params) ? hotelDetails.params.booking_source : null,
      search_id: (roomDetails && roomDetails.params) ? roomDetails.params.search_id : null,
      ResultIndex: (hotelDetails && hotelDetails.params) ? hotelDetails.params.ResultIndex : null,
      op: 'block_room',
      GuestNationality: 'IN',
      token: tk, // roomDetails.raw_room_list.GetHotelRoomResult.token.token,
      token_key: tkey // roomDetails.raw_room_list.GetHotelRoomResult.token.token_key
    }


    history.push({
      pathname: '/hotel-booking',
      state: obj
    })
  }

  const dataHotel = [
    {
        roomCategoty: 'Honey Comb',
        priceCP: 9500,
        priceMAP: 11000,
        extraAdultCP: 2500,
        extraChildCP: 1500,
        extraAdultMAP: 3000,
        extraChildMAP: 2000,
    },
    {
        roomCategoty: 'Mellow Glory',
        priceCP: 10500,
        priceMAP: 12000,
        extraAdultCP: 2500,
        extraChildCP: 1500,
        extraAdultMAP: 3000,
        extraChildMAP: 2000,
    },
    {
        roomCategoty: 'Euphoria',
        priceCP: 12000,
        priceMAP: 13500,
        extraAdultCP: 2500,
        extraChildCP: 1500,
        extraAdultMAP: 3000,
        extraChildMAP: 2000,
    },
    {
        roomCategoty: 'Rukum',
        priceCP: 14500,
        priceMAP: 16000,
        extraAdultCP: 2500,
        extraChildCP: 1500,
        extraAdultMAP: 3000,
        extraChildMAP: 2000,
    },
    {
        roomCategoty: 'Bliss',
        priceCP: 16500,
        priceMAP: 18000,
        extraAdultCP: 2500,
        extraChildCP: 1500,
        extraAdultMAP: 3000,
        extraChildMAP: 2000,
    },
  ]

  useEffect(() => {
   
  }, [])

  return <>
   
      {/* <UpdateHotel hotelInfo={props.location.state[1]} travellerCount={props.location.state[2]} /> */}
      <div>
          <Container>
            <Row >
                <Col xs={12} md={9}>    
                    <Row className="hotelrow">           
                        <Col xs={12} sm={12} md={12} lg={12} className="mb-3">
                            <div className="tlthotelwithstr ">
                                <div className="tlthtlstr">Paddington Resort and Spa</div>
                                <div className="tltstr">
                                    <ul>
                                        <li><img src={star} alt="star" className="starico"></img></li>
                                        <li><img src={star} alt="star" className="starico"></img></li>
                                        <li><img src={star} alt="star" className="starico"></img></li>
                                        <li><img src={star} alt="star" className="starico"></img></li>
                                        <li><img src={starinactive} alt="star" className="starico"></img></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="hoteladdress"><p><LocationOnIcon />   7th Hosakote, Thondoor Village,Suntikoppa Post, Somwarpet, Kodagu, Kushalnagar , Coorg, India</p></div>
                        </Col>
                        <Col xs={12} sm={12} md={5} lg={7} className="pr-0">
                            <div className="singleimgbox"><img src={"https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351607/Domestic Hotels/Hotels_Coorg/Paddington Resort/pool.jpg"} alt=""></img></div>
                        </Col>
                        <Col xs={12} sm={12} md={3} lg={5} >
                            <Row>
                                <Col xs={8} sm={6} md={12} lg={12}>
                                    <div className="multiimgbox"><img src={"https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351606/Domestic Hotels/Hotels_Coorg/Paddington Resort/Pool_3.jpg"} alt=""></img></div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6} sm={5} md={6} lg={6} className="pr-1">
                                    <div className="sideimgboxleft"><img src={"https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350155/Domestic Hotels/Hotels_Coorg/Paddington Resort/Rukam_Exterior_2.jpg"} alt=""></img></div>
                                </Col>
                                <Col xs={6} sm={7} md={6} lg={6} className="pl-1">
                                    <div className="sideimgboxright">
                                        <img src={"https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350191/Domestic Hotels/Hotels_Coorg/Paddington Resort/Mellow_Glory.jpg"} alt=""></img>
                                        {/* <NavLink className="linkviewhotel" to="gallery">View More</NavLink> */}
                                        <Button onClick={handleModalOpen} className="viewallimg-btn"><div className="linkviewhotel">+view All</div></Button>
                                        {/* {advanceShow && (
                                            <HotelBanner/>
                                        )} */}
                                    </div>

                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} className="colspacemini">
                                    <Box sx={{ position: 'relative' }}>
                                        <Modal
                                        className="banner-modal"
                                            open={modal}
                                            onClose={handleModalClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                            >
                                            <Box className='modal-banner-body'>
                                                <Button className='close-modal-btn' onClick={handleModalClose}>Close</Button>
                                                <HotelBanner  />
                                            </Box>
                                        </Modal>
                                    </Box>
                                </Col>
                            </Row>
                            

                        </Col>
                    </Row>   
                    <Row className="tabsrow selecthoteltabs" id="rooms">
                        <Col xs={12} sm={12} md={12} lg={12} className="coltabspace">
                            <Tabs
                                className="tabswdth"
                                value={value}
                                onChange={handleTabinChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                aria-label="full width tabs example"
                            >
                                <Tab className="hoteltab" label="About the hotel" {...hotelTabPanel(0)} />
                                <Tab className="hoteltab" label="Rooms" {...hotelTabPanel(1)} />
                                <Tab className="hoteltab" label="Inclusions" {...hotelTabPanel(2)} />
                                {/* <Tab className="hoteltab" label="Location" {...hotelTabPanel(3)} /> */}
                                <Tab className="hoteltab" label="Adventure Activities" {...hotelTabPanel(3)} />
                            </Tabs>

                            <TabPanel value={value} index={0} >
                                <Row className="roomdetailsbookingbox py-3 px-2">
                                    <Col xs={12} sm={12}>
                                        <div className="desc-tlt">
                                        <h6 className='mb-3'><b>Property Description:</b></h6>
                                        <p>Enjoy a luxurious experience in a beautiful setting! </p>

                                        <p>Paddington Resort And Spa is a 4-star resort conveniently positioned at Kushalnagar in Coorg. This luxury 
                                            property is around 2.5 km from Chikliholle Falls. The resort offers activities like plantation tours for the guests and special arrangements 
                                            like candle light dinner for honeymooners.</p>

                                        <p>The resort provides facilities like an inviting swimming pool, state-of-the-art fitness centre, and spa. 
                                            Guests can enjoy activities like plantation tours, cycling, outdoor games like rifle shooting, archety, rope activities,
                                            zipline etc. Free Wi-Fi connectivity is available for all guests. It also offers other facilities like a travel desk and 
                                            doctor-on-call service.</p>

                                        <p>The property features 29 thematic cottages. All rooms here are equipped with TV with satellite channels, tea/ coffee maker, 
                                            and in room safe. Guests can enjoy in-room services like newspaper and room service.</p>

                                        <p>Paddington Resort and Spa features an in-house restaurant that treats diners to authentic Indian and multi-cuisine fare.</p>

                                        <p> Chikliholle Falls and Dam are located 2.5 km from the property. Dubare Elephant Camp is 12 km away, 
                                            Madikeri Fort is at a distance of 15 km from the property, and Raja Seat is 15 km away.</p>

                                        <p>The Mysore Airport is about 117 km from the property. The nearest railway stations are at Kannur
                                            (121 km) and Kasargode (134 km).</p>

                                        <p>What makes this property a first choice among travellers is its exceptional setting and excellent 
                                            services.</p>

                                            <b>Book Paddington Resort And Spa now and revel in the best! </b>
                                        </div>
                                        <div className="paratabtext">
                                        </div>
                                    </Col>
                                </Row>
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                {dataHotel.map((data, index) => {
                                return(
                                    <Row className={`roomdetailsbookingbox ${selectText && menuIndex === index ? 'selected': ''}`} key={index}>
                                        <Col xs={12} sm={12} md={3}>
                                            <div className="roombox">
                                                <div className="roomdtlstlt">{data.roomCategoty}</div>
                                                <div className="miniico-roomdtls">
                                                    <PersonIcon /> <span>2 Adult(s)</span>
                                                </div>
                                                <div className="miniico-roomdtls mt-2">
                                                    <HotelIcon /> <span>No. of Room(s): 1</span>
                                                </div>
                                                <div className="viewdtlshotelcls mt-3">
                                                    <Link color="inherit" className="pointercls" onClick={() => handleClickOpen()}>
                                                        View cancellation policy
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={9} className="border-left">
                                            <Row>
                                                <Col xs={12} sm={5}>
                                                    <div className='heading-hd mt-3'>
                                                        <h6>Continental Plan (CP)</h6>
                                                    </div>
                                                    <div className="cancellationboxhotel">
                                                        <div className="facility-list"> 
                                                            <span><CheckIcon /> Accomadation</span>
                                                            <span><CheckIcon />  Breakfast</span>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={7} className="m-auto">
                                                    <div className='d-flex'>
                                                        <div className="roomrent">
                                                            <div className="rmrentrate"><span>&#x20B9; </span>{data.priceCP}</div>
                                                            <div className="hd-child-rate">Extra Adust Cost: <b><span>&#x20B9; </span> {data.extraAdultCP}</b></div>
                                                            <div className="hd-child-rate">Extra Child Cost: <b><span>&#x20B9; </span> {data.extraChildCP}</b></div>
                                                            <div className="rmrentview">1 room per night</div>
                                                        </div>
                                                        <div className="btnbookhotel">
                                                            {console.log(selectText)}
                                                            <Button variant="contained" color="primary" onClick={() => selectRoomCategory(index)}>
                                                                {selectText && index === menuIndex ? <><CheckCircleIcon /> &nbsp;Selected</> : 'Select'}</Button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className='hd-border-top'>
                                                <Col xs={12} sm={5}>
                                                    <div className='heading-hd mt-3'>
                                                        <h6>Media American Plan (MAP)</h6>
                                                    </div>
                                                    <div className="cancellationboxhotel">
                                                        <div className="facility-list"> 
                                                            <span><CheckIcon /> Accomadation</span>
                                                            <span><CheckIcon />  Breakfast</span>
                                                            <span><CheckIcon />  Lunch</span>
                                                            <span><CheckIcon />  Dinner</span>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={7} className="m-auto ">
                                                    <div className='d-flex'>
                                                    <div className="roomrent">
                                                            <div className="rmrentrate"><span>&#x20B9; </span>{data.priceMAP}</div>
                                                            <div className="hd-child-rate">Extra Adust Cost: <b><span>&#x20B9; </span> {data.extraAdultMAP}</b></div>
                                                            <div className="hd-child-rate">Extra Child Cost: <b><span>&#x20B9; </span> {data.extraChildMAP}</b></div>
                                                            <div className="rmrentview">1 room per night</div>
                                                        </div>
                                                    
                                                        <div className="btnbookhotel">
                                                            <Button variant="contained" color="primary" onClick={() => selectRoomCategory(index)}>
                                                            {selectText && index === menuIndex ? <><CheckCircleIcon /> &nbsp;Selected</> : 'Select'}</Button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    )
                                })}

                                <Dialog
                                    onClose={() => handleClose(null)}
                                    aria-labelledby="customized-dialog-title"
                                    open={open}
                                    >
                                    <DialogTitle className="canc-dialog-heading" id="customized-dialog-title" onClose={() => handleClose(null)}>
                                        <h6 className='text-danger'>Cancellation Policy</h6>
                                    </DialogTitle>
                                    <DialogContent dividers>

                                    <Box className="formboxguest">
                                        <div className="facility-list cancel-list">
                                            <ul>
                                                <li className='d-flex'>
                                                    <CheckIcon /> <span>All reservations require a guarantee in the form of a credit card, cash deposit.</span>
                                                </li>   
                                                <li className='d-flex'>
                                                    <CheckIcon /> <span>Any cancellation requests made after confirming the booking will hold 100% of advance payment and cancellation request made
                                                    will incur the room charges for the entire stay.</span>
                                                </li> 
                                                <li className='d-flex'>
                                                    <CheckIcon /> <span>There may be a change in the nightly rate if dates of stay are modified.</span>
                                                </li>   
                                            </ul> 
                                        </div>
                                    </Box>
                                <Box>
                                   
                                </Box>
                                </DialogContent>
                            </Dialog>
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <Row className="roomdetailsbookingbox">
                                    <Col xs={12} sm={12}>
                                        <div className="cancellationboxhotel px-3 pt-3 pb-4">
                                            <h6 className='mb-3'><b>Package Inclusions:</b></h6>
                                            <div className="facility-list inclu-list"> 
                                                <span><CheckIcon /> Welcome drink on arrival</span>
                                                <span><CheckIcon /> Complimentary Breakfast & Dinner @ Restaurant.</span>
                                                <span><CheckIcon /> Unlimited High-Speed Wi-Fi/Internet access</span>
                                                <span><CheckIcon /> Use of indoor & outdoor games</span>
                                                <span><CheckIcon /> 30% Discount on Spa</span>
                                                <span><CheckIcon /> Common bonfire (If weather permits)</span>
                                                <span><CheckIcon /> Coffee plantation walk and all apllicable taxes</span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                               
                            </TabPanel>
                            <TabPanel value={value} index={3} >
                                <Row className="roomdetailsbookingbox">
                                    <Col xs={12} sm={12}>
                                        <div className="cancellationboxhotel px-3 pt-3 pb-4">
                                            <h6 className='mb-3'><b>Additional Cost for Adventure Activities:</b></h6>
                                            <div className="facility-list activity-list"> 
                                            <Row>
                                                <Col xs={12} sm={6}>
                                                    <span className='activity-span'><span className='activity-1'><RowingIcon />  Zipline</span>  <span className='activity-2'> &#x20B9; 500 + 18% tax (Oneway)</span></span>
                                                </Col>

                                                <Col xs={12} sm={6}>
                                                    <span className='activity-span'><span className='activity-1'><RowingIcon />  Archery</span>  <span className='activity-2'> &#x20B9; 150 + 18% tax (3 Shoots)</span></span>
                                                </Col>

                                                <Col xs={12} sm={6}>
                                                    <span className='activity-span' ><span className='activity-1'><RowingIcon />  Rifle Shooting</span>  <span className='activity-2'> &#x20B9; 200 + 18% tax (3 Shoots)</span></span>
                                                </Col>

                                                <Col xs={12} sm={6}>
                                                    <span className='activity-span'><span className='activity-1'><RowingIcon />  Cycling Tour</span>  <span className='activity-2'> &#x20B9; 550 + 18% tax (One Session)</span></span>
                                                </Col>

                                                <Col xs={12} sm={6}>
                                                    <span className='activity-span'><span className='activity-1'><RowingIcon />  Fish Feeding</span>  <span className='activity-2'> &#x20B9; 100 + 18% tax (One Session)	</span></span>
                                                 </Col>
                                            </Row>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPanel>
                        </Col>
                    </Row>

                    <Row className='tabsrow selecthoteltabs'>
                        <Col xs={12} sm={12}>
                            <div className="facility-list cancel-list pt-2">
                                <h6>Child Policy: </h6>
                                <ul>
                                    <li className='d-flex'>
                                        <CheckIcon /> <span>Two Children below 5 years can share the existing beds with adults without any extra fee.</span>
                                    </li>   
                                    <li className='d-flex'>
                                        <CheckIcon /> <span>Child above 11years considered to be an extraperson & will be charged accordingly.</span>
                                    </li> 
                                </ul> 
                            </div>
                        </Col>
                    </Row>
                </Col>  
                <Col xs={12} md={3} className=" sticky-parent"> 
                    <div className="ratedetailcard hotelrow package-wrapper sticky-child">
                        <Box className="clsroomst btnGroup">
                              
                                <Box className="">

                                    <Box className="travellerroom-tlt">Selected Room</Box>
                                    <Box className='selected-room'>
                                        <p className='text-xs'>Room Category: <br></br>
                                        <b>Bliss (Continental Plan) </b></p>
                                    </Box>

                                    <Box className="travellerroom-tlt">Select Date</Box>
                                    <Box className='check-date'>
                                        <Box className="text-xs mt-2 mb-1"><b>Check-in</b></Box>

                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                className="daterequest"
                                                variant="inline"
                                                autoOk
                                                inputVariant="outlined"
                                                size="small"
                                                id="date-picker-dialog"
                                                format="dd-MMM-yyyy"
                                                disableFuture
                                                name={'toDate'}
                                                maxDate={new Date()}
                                                emptyLabel="To Date"
                                                onChange={() => new Date()}

                                            />
                                        </MuiPickersUtilsProvider>
                                    </Box>
                                    
                                    <Box className='check-date'>
                                        <Box className="text-xs mt-2 mb-1"><b>Check-out</b></Box>

                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                className="daterequest"
                                                variant="inline"
                                                disableToolbar
                                                autoOk
                                                inputVariant="outlined"
                                                size="small"
                                                id="date-picker-dialog"
                                                format="dd-MMM-yyyy"
                                                disableFuture
                                                name={'toDate'}
                                                maxDate={new Date()}
                                                emptyLabel="To Date"
                                                onChange={() => new Date()}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Box>
                                    <Box className="travellerroom-tlt mt-4">Travellers</Box>

                                    {travellerCount.map((value, index) => (
                                      <>
                                      <Box className="travellerroom-tltmini" key={index}>
                                          <div className="tltminirms"><h6>Room {index + 1}</h6></div>
                                          <div className="dataroomsset">
                                              <div className="tlttravellertype">Adults</div>
                                              <div className="btnincreasecount">
                                                  <ButtonGroup
                                                      size="small"
                                                      aria-label="small outlined button group"
                                                      className="btnGroup"
                                                      >
                                                      <Button className="btnGroup" onClick={() => {
                                                        handleCountMinus(index, 'adults')
                                                      }}>-</Button>
                                                      <Button className="btnGroup">
                                                          {value.adult[0]}
                                                      </Button>
                                                      <Button className="btnGroup" onClick={() => {
                                                        handleCountPlus(index, 'adults')
                                                      }}>+</Button>
                                                  </ButtonGroup>
                                              </div>
                                          </div>

                                          <div className="dataroomsset">
                                              <div className="tlttravellertype">
                                                  <span className="">Children</span>
                                                  <span className="ageyrs">Ages 0 to 17</span>
                                              </div>
                                              <div className="btnincreasecount">
                                              <ButtonGroup
                                                      size="small"
                                                      aria-label="small outlined button group"
                                                      className="btnGroup"
                                                      >
                                                      <Button className="btnGroup" onClick={() => {
                                                        handleCountMinus(index, 'child')
                                                      }}>-</Button>
                                                      <Button className="btnGroup">
                                                          {value.child[0]}
                                                      </Button>
                                                      <Button className="btnGroup" onClick={() => {
                                                        handleCountPlus(index, 'child')
                                                      }}>+</Button>
                                                  </ButtonGroup>
                                              </div>
                                          </div>
                                          <div className="ageslistchild">
                                            <Container className=" px-0">
                                              <Row>

                                              {[...Array(Number(value.child))].map((chValue, chIndex) => (
                                                <>
                                                  <Col xs={12} key={chIndex}>
                                                  <FormControl size="small" variant="filled" className="agecontrol">
                                                    <InputLabel htmlFor="filled-age-native-simple">Child {chIndex + 1} Age</InputLabel>
                                                    <Select
                                                      className="agecontrolselect"
                                                      native
                                                      value={value.childAge[chIndex]}
                                                      onChange={(e) => {
                                                        const tc = [...travellerCount]
                                                        tc[index].childAge[chIndex] = e.target.value
                                                        setTravellerCount(tc)
                                                      }}
                                                      inputProps={{
                                                        name: 'age',
                                                        id: 'filled-age-native-simple'
                                                      }}
                                                    >
                                                      <option value={1}>Under 1</option>
                                                      <option value={2}>2</option>
                                                      <option value={3}>3</option>
                                                      <option value={4}>4</option>
                                                      <option value={5}>5</option>
                                                      <option value={6}>6</option>
                                                    </Select>
                                                  </FormControl>

                                                </Col>
                                                </>
                                              ))}

                                              </Row>
                                            </Container>
                                          </div>
                                      </Box>
                                      </>
                                    ))}

                                    <Box className="travellerroom-update">
                                        <div className="setFlexbtn">
                                        {travellerCount.length > 1 && (
                                        <div className="setdatabtn"><Button startIcon={<DeleteIcon />} variant="contained" color="secondary" onClick={handleRemoveRoom}></Button></div>
                                        )}

                                        {travellerCount.length + 1 <= 4 && (
                                        <div className="setdatabtn"><Button startIcon={<AddIcon />} variant="contained" color="primary" onClick={handleAddRoom}></Button></div>
                                        )}
                                    </div>
                                    </Box>

                                    <Box className="travellerroom-btn">
                                        <Button className="btndone" variant="contained" color="primary" onClick={() => handleBookingDetails()}>Book Now <br/>
                                        {travellerCount.length} Room, {travellerCount.map(paxCount).reduce(sum)} Guest
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </div>
                    </Col>
                </Row>

            
          </Container>
      </div>
  </>;
}

export default HotelDetails